// VpmTab — Virtual Product Manager (PM Phase 1, без LLM).
// Показывает снапшот ключевых метрик продукта (read-only). Кнопка генерации
// LLM-рекомендаций отключена: блокер — не подписан Anthropic DPA (PII в Claude
// API в проде запрещён). Генерация появится в Phase 2 после подписания DPA.
import React, { useCallback, useEffect, useState } from 'react';
import { Card, Row, Col, Spinner, Alert, Button } from 'react-bootstrap';
import ApiService from '../../helpers/apiService';

const Metric: React.FC<{ label: string; value: React.ReactNode; hint?: string }> = ({ label, value, hint }) => (
  <Card className="mb-3 h-100">
    <Card.Body>
      <div className="text-muted small">{label}</div>
      <div className="fs-3 fw-bold">{value}</div>
      {hint && <div className="text-muted small fst-italic">{hint}</div>}
    </Card.Body>
  </Card>
);

const VpmTab: React.FC = () => {
  const [snapshot, setSnapshot] = useState<any>(null);
  const [aml, setAml] = useState<number>(0);
  const [kyc, setKyc] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const [statsRes, amlRes, kycRes] = await Promise.allSettled([
      ApiService.dashboardStats(),
      (ApiService as any).amlGetActiveCount(),
      (ApiService as any).kycGetActiveCount(),
    ]);
    if (statsRes.status === 'fulfilled') setSnapshot(statsRes.value);
    if (amlRes.status === 'fulfilled') setAml(amlRes.value);
    if (kycRes.status === 'fulfilled') setKyc(kycRes.value);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <Card.Title className="mb-0">VPM — здоровье продукта</Card.Title>
        <Button variant="outline-secondary" size="sm" onClick={load} disabled={loading}>Обновить</Button>
      </Card.Header>
      <Card.Body>
        <Alert variant="warning" className="mb-3">
          LLM-генерация рекомендаций недоступна: ожидается подписание Anthropic DPA
          (отправка PII в Claude API в проде запрещена). Пока — снапшот метрик в режиме чтения.
        </Alert>
        {loading && !snapshot ? (
          <div className="d-flex align-items-center gap-2 p-2"><Spinner animation="border" size="sm" /><span>Загрузка…</span></div>
        ) : (
          <Row>
            <Col xs={12} sm={6} lg={3}><Metric label="Операторы" value={snapshot?.operators ?? '—'} /></Col>
            <Col xs={12} sm={6} lg={3}><Metric label="Активные сессии" value={snapshot?.active_sessions ?? '—'} /></Col>
            <Col xs={12} sm={6} lg={3}><Metric label="Действий за 24ч" value={snapshot?.actions_today ?? '—'} /></Col>
            <Col xs={12} sm={6} lg={3}><Metric label="Активные AML" value={aml} hint="pending + in_review" /></Col>
            <Col xs={12} sm={6} lg={3}><Metric label="Очередь KYC" value={kyc} hint="PENDING + ON_HOLD" /></Col>
          </Row>
        )}
        <div className="d-flex justify-content-end">
          <Button variant="primary" disabled title="Недоступно до подписания Anthropic DPA">
            Сгенерировать рекомендации
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default VpmTab;
